import type { LogoClassType, NavElements } from '@Types/Shared/Header';
import type { SiteType } from '@Types/Shared/SiteDatas';

import clsx from 'clsx';

export default function Logo({
	site,
	logo,
	itemClass,
	position,
}: {
	site: SiteType;
	logo?: string;
	itemClass: LogoClassType;
	position?: NavElements;
}) {
	const style = clsx(
		`w-full ${itemClass.wrapper ? itemClass.wrapper : ''}`,
		position?.center ? 'desktop:w-auto' : ''
	);
	return (
		<div className={style}>
			<a href={site.url} className='block'>
				{logo ? <img src={logo} alt={site.name} className={itemClass.logo} /> : ''}
			</a>
		</div>
	);
}
